import type { Severity } from '@360t/shared';

const STYLES: Record<Severity, string> = {
  critical: 'bg-poor/10 text-poor',
  warning: 'bg-average/15 text-amber-700',
  info: 'bg-accent/10 text-accent',
};

const LABELS: Record<Severity, string> = {
  critical: 'Critical',
  warning: 'Attention',
  info: 'Opportunity',
};

export function SeverityBadge({ severity }: { severity: Severity }) {
  return (
    <span className={`rounded px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${STYLES[severity]}`}>
      {LABELS[severity]}
    </span>
  );
}
